var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "FormGroup",
                { attrs: { state: _vm.valid } },
                [
                  _c("b-input", {
                    attrs: { type: "password", placeholder: _vm.placeholder1 },
                    on: {
                      focusin: function($event) {
                        _vm.showRequirements = true
                      },
                      focusout: function($event) {
                        _vm.showRequirements = false
                      },
                      input: _vm.emitChangeEvent
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "FormGroup",
                { staticClass: "mt-2 mt-md-0", attrs: { state: _vm.valid } },
                [
                  _c("b-input", {
                    attrs: { type: "password", placeholder: _vm.placeholder2 },
                    on: {
                      focusin: function($event) {
                        _vm.showRequirements = true
                      },
                      focusout: function($event) {
                        _vm.showRequirements = false
                      },
                      input: _vm.emitChangeEvent
                    },
                    model: {
                      value: _vm.password2,
                      callback: function($$v) {
                        _vm.password2 = $$v
                      },
                      expression: "password2"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showRequirements || _vm.bothFilled
        ? _c(
            "FormGroup",
            [
              _c("Requirements", {
                attrs: { prefix: "Mindestens:", requirements: _vm.requirements }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }